import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CaseStudy } from '../data/caseStudies';
interface CaseStudyCardProps {
  study: CaseStudy;
}
export function CaseStudyCard({
  study
}: CaseStudyCardProps) {
  const {
    lang,
    t
  } = useLanguage();
  return <article className="grid h-full gap-6 rounded-[20px] bg-white p-5 shadow-[0_10px_30px_rgba(8,8,82,0.06)] sm:p-6 md:grid-cols-[1fr_1.45fr] md:gap-8" data-id="element-31" data-mp="1lclxat747f7c">
      {/* Texte */}
      <div className="flex flex-col" data-id="element-32" data-mp="292yc8o0s2c7f">
        <img src={study.logo} alt={study.company} className={`${study.logoClassName ?? 'h-6 sm:h-7'} w-auto self-start object-contain`} data-id="element-33" data-mp="2e0zw3b612fjy" />

        <div className="mt-8 md:mt-auto" data-id="element-34" data-mp="2081uv86wlt8h">
          <p className="text-[14px] text-blue-reways-950-lock" data-id="element-35" data-mp="24aojl08a2y1g">{t.cases.objective}</p>
          <p className="mt-2 font-hero text-[22px] font-medium leading-[1.6] text-blue-reways-950-lock sm:text-[24px]" data-id="element-36" data-mp="2s0iqz29tvueb">
            <span className="box-decoration-clone px-1" style={{
            backgroundImage: 'linear-gradient(90deg, rgba(129,129,240,0.32) 0%, rgba(129,129,240,0.18) 55%, rgba(129,129,240,0.04) 100%)',
            backgroundSize: '100% 72%',
            backgroundPosition: 'center 55%',
            backgroundRepeat: 'no-repeat'
          }} data-id="element-37" data-mp="2wssnj15g7spk">
              {study.objective[lang]}
            </span>
          </p>
        </div>

        <div className="mt-8 md:mt-auto" data-id="element-38" data-mp="3cf8hsevtmppf">
          <p className="text-[14px] text-blue-reways-950-lock" data-id="element-39" data-mp="38eyfbc78mhfb">
            {study.contextLabel?.[lang] ?? t.cases.context}
          </p>
          <p className="mt-1 text-[14px] text-grey-800-lock" data-id="element-40" data-mp="3mdoc0qq5af35">{study.context[lang]}</p>
        </div>
      </div>

      {/* Photo + témoignage (ou panneau de marque si pas encore de photo) */}
      <figure className="relative min-h-[260px] overflow-hidden rounded-[16px]" data-id="element-41" data-mp="1rzwtt2tr2mw3">
        {study.photo ? <img src={study.photo} alt={study.photoAlt?.[lang] ?? `${t.cases.storeAlt} ${study.company}`} loading="lazy" className="aspect-[4/3] h-full w-full object-cover md:aspect-auto" data-id="element-42" data-mp="1n2n89y9hevdj" /> : <div className="flex aspect-[4/3] h-full w-full items-center justify-center bg-grey-50 md:aspect-auto" data-id="element-43" data-mp="3w4j8dbjp4ha8">
            <img src={study.logo} alt="" aria-hidden="true" className="h-28 w-auto object-contain opacity-90 sm:h-32" data-id="element-44" data-mp="4xzxxxhrutcg" />
          </div>}
        {study.quote && study.author && <figcaption className="absolute inset-x-3 bottom-3 rounded-xl border border-white/25 bg-[rgba(70,70,120,0.45)] p-4 text-white backdrop-blur-md sm:inset-x-auto sm:bottom-5 sm:left-[14%] sm:right-5" data-id="element-45" data-mp="eul80x8neun5">
          <blockquote className="text-[13px] leading-[1.6] sm:text-[14px]" data-id="element-46" data-mp="nqu5w7gz9l76">
            “{study.quote.before[lang]}
            <strong className="font-semibold" data-id="element-47" data-mp="slzsz9m495wu">{study.quote.strong[lang]}</strong>
            {study.quote.after[lang]}”
          </blockquote>
          <div className="mt-3 flex items-center gap-3" data-id="element-48" data-mp="17rvpzjynk9dr">
            {study.author.avatar ? <img src={study.author.avatar} alt="" aria-hidden="true" className="h-9 w-9 shrink-0 rounded-full object-cover ring-2 ring-white/70" data-id="element-49" data-mp="12qpwhjx64i36" /> : <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-[12px] font-semibold text-blue-reways-950-lock" data-id="element-50" data-mp="tt5w0d74qptm">
                {study.author.initials}
              </span>}
            <span className="text-[12px] leading-tight sm:text-[13px]" data-id="element-51" data-mp="1gpfs0v4ca9pf">
              <span className="block font-semibold" data-id="element-52" data-mp="1cp5lnhcmxha1">{study.author.name}</span>
              <span className="mt-1 block text-white/80" data-id="element-53" data-mp="298381w4hayjn">{study.author.role[lang]}</span>
            </span>
          </div>
        </figcaption>}
      </figure>
    </article>;
}